import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Brand */}
          <Link to="/" className="flex items-center flex-shrink-0 group">
            {/* Brand Name + Registration */}
            <div className="flex flex-col">
              <div className="flex items-baseline gap-1.5">
                <span
                  className={`font-heading font-extrabold text-base md:text-lg leading-none tracking-tight whitespace-nowrap transition-colors duration-300 ${
                    scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
                  }`}
                >
                  INSAN
                </span>
                <span
                  className={`font-heading font-extrabold text-base md:text-lg leading-none tracking-tight whitespace-nowrap transition-colors duration-300 ${
                    scrolled || !isHome ? 'text-primary-500' : 'text-primary-300'
                  }`}
                >
                  PERWIRA
                </span>
              </div>
              <span
                className={`text-[10px] md:text-[11px] font-medium tracking-[0.15em] uppercase whitespace-nowrap transition-colors duration-300 ${
                  scrolled || !isHome ? 'text-foreground-400' : 'text-background-50/55'
                }`}
              >
                {siteInfo.registrationNumber}
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              const isDonate = link.label === 'Donate';
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isDonate
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600 ml-2'
                      : isActive
                        ? scrolled || !isHome
                          ? 'bg-background-200 text-foreground-950'
                          : 'bg-background-50/20 text-background-50'
                        : scrolled || !isHome
                          ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                          : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Mobile Burger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              const isDonate = link.label === 'Donate';
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                    isDonate
                      ? 'bg-primary-500 text-background-50 text-center mt-1'
                      : isActive
                        ? 'bg-background-200 text-foreground-950'
                        : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}